// Polyfill for flatMap on older Safari versions
import "array-flat-polyfill";
import ReactDOM from "react-dom";
import App from "./TBLDotComApp";
import "./index.css";

ReactDOM.render(<App />, document.getElementById("root"));
